export default "__VITE_ASSET__GWm99ff1__"